import { Zap } from "lucide-react";

/**
 * NexaTokensChip — live balance indicator with cyan glow.
 *
 * `pulse` prop (boolean) toggles a one-shot neon burst animation, used when
 * the user just did something that COULD earn tokens (e.g., copied the share
 * link). The burst is CSS-only and self-cancelling.
 */
export function NexaTokensChip({ balance = 0, pulse = false, size = "sm", className = "" }) {
  const isLg = size === "lg";
  return (
    <span
      className={
        "nx-chip inline-flex items-center gap-1.5 rounded-full font-mono font-semibold transition-shadow " +
        (isLg ? "px-3 py-1.5 text-sm " : "px-2.5 py-1 text-xs ") +
        (pulse ? "nx-chip-pulse " : "") +
        className
      }
      style={{
        color: "#00f0ff",
        background: "rgba(0, 240, 255, 0.08)",
        border: "1px solid rgba(0, 240, 255, 0.35)",
        boxShadow: pulse ? undefined : "0 0 10px rgba(0, 240, 255, 0.12)",
      }}
      data-testid="nexatokens-chip"
      data-balance={balance}
      aria-label={`${balance} NexaTokens`}
    >
      <Zap size={isLg ? 14 : 12} strokeWidth={2.6} />
      <span>{balance}</span>
      <span className="text-slate-400 font-normal">NexaTokens</span>
      <style>{`
        @keyframes nx-chip-burst {
          0%   { box-shadow: 0 0 0 0 rgba(0, 240, 255, 0.5), 0 0 16px rgba(0, 240, 255, 0.25); transform: scale(1); }
          25%  { box-shadow: 0 0 0 8px rgba(0, 240, 255, 0.0), 0 0 26px rgba(0, 240, 255, 0.6); transform: scale(1.08); }
          70%  { box-shadow: 0 0 0 0 rgba(0, 240, 255, 0.0), 0 0 20px rgba(0, 240, 255, 0.35); transform: scale(1.02); }
          100% { box-shadow: 0 0 10px rgba(0, 240, 255, 0.12); transform: scale(1); }
        }
        .nx-chip-pulse {
          animation: nx-chip-burst 1200ms ease-out;
        }
      `}</style>
    </span>
  );
}
